import { Evaluacion } from './evaluacion.model';
import { Ponderacion } from './ponderacion.model';
import { FactorPonderacion } from './factor-ponderacion.model';

export class PonderacionEvaluacion
{
    id: number;
    evaluacion: Evaluacion;
    factor: Ponderacion;
    /**
     * Constructor
     *
     * @param factor
     */
    constructor(factor)
    {
        {
            this.id = factor.id || null;
            this.evaluacion = factor.evaluacion;
            this.factor = factor.factor;

        }
    }
}
